import React, { memo } from "react";
import { css } from "@emotion/core";
import WithStyles from "shared/components/WithStyles";
import ResponsiveLoader from "shared/components/ResponsiveLoader";
import { DWEB_MAX_WIDTH, FONTS, BREAKPOINTS } from "shared/styles/base";

import Category from "./components/Category";
import CollapsibleCategories from "./components/CollapsibleCategories";

import Data from "shared/components/Footer/data";

const catsCss = css`
    padding: 26px 0 36px 0;

    .content {
        display: flex;
        max-width: ${DWEB_MAX_WIDTH}px;
        font-family: ${FONTS.CERA};
        color: #666;
        margin: 0 auto;
        padding: 0 10px;
    }
`;

function Categories() {
    return (
        <>
            <ResponsiveLoader breakpoint={600} up>
                <WithStyles cssProps={catsCss}>
                    <div className="content">
                        {Data.map((cat, idx) => (
                            <Category {...cat} key={idx} />
                        ))}
                    </div>
                </WithStyles>
            </ResponsiveLoader>
            <ResponsiveLoader breakpoint={600} down>
                <CollapsibleCategories />
            </ResponsiveLoader>
        </>
    );
}

export default memo(Categories);
